export default __webpack_public_path__ + "0eaf98c71161f65050eeb511be379c8f.png";